import { Directive, Input, Output, ElementRef, Injector, SimpleChanges, EventEmitter } from '@angular/core';
import { UpgradeComponent } from "@angular/upgrade/static";

// This Angular directive will act as an interface to the "upgraded" AngularJS component
@Directive({ selector: 'feedback-execution-screen' })
export class FeedbackExecutionComponentWrapper extends UpgradeComponent {
    // The names of the input and output properties here must match the names of the
    // `<` and `&` bindings in the AngularJS component that is being wrapped
    @Input() jobMatchId: any;
    @Input() candidateId: any;
    @Input() feedbackUserIdsList: any;
    @Input() loginRequired: any;
    @Input() externalCommentRequired: any;
    @Input() feedbackType: any;
    @Input() parentScheduleId: any;
    @Input() childScheduleId: any;
    @Input() context: any;
    @Input() usersToEditFeedback: any;
    @Input() feedbackReadOnly: any;
    @Input() externalMeetingCallId: any;
    @Input() activeOutreachFeedbackQuestionsList: any;
    @Input() outreachData: any;
    @Input() disableFeedbackQuestions: any;
    @Input() isFeedbackTabActive: any;
    @Output() completeFeedbackCallback: any;
    @Output() saveCallback: any;
    @Output() candidateContactDetailsMissingCallback: any;

    constructor(elementRef: ElementRef, injector: Injector) {
        // We must pass the name of the directive as used by AngularJS to the super
        super('feedbackExecutionScreen', elementRef, injector);
        
    }

    saveOutreachFeedback(successCallback: any) {
        const ctrl = (this as any).controllerInstance;
        if (ctrl && typeof ctrl.saveOutreachFeedback === 'function') {
            ctrl.saveOutreachFeedback(successCallback);
        } else {
            console.error("saveOutreachFeedback not available on feedbackExecutionScreen controller");
        }
    }


    ngOnInit() {
        super.ngOnInit();
    }
    ngOnChanges(changes: SimpleChanges) {
        super.ngOnChanges(changes);
    }
    ngDoCheck() { super.ngDoCheck(); }
    ngOnDestroy() { super.ngOnDestroy(); }
}